import { __ } from '@wordpress/i18n';
import React, { createContext, useContext, useState } from "react";
import Global from "../assets/images/global.svg";
import Role from "../assets/images/role.svg";
import More from "../assets/images/More.svg";
import Feedback from "../assets/images/Feedback.svg";
import Review from "../assets/images/Review.svg";
import SupportCenter from "../assets/images/SupportCenter.svg";
import OtherPlugin from "../assets/images/OtherPlugin.svg";

const MenuContext = createContext();

const menuData = [
    {
      title: __("User Role Editor", "access-control"),
      url: "/roles",
      icon: Role,
      sub: [
        {
          title: __("Edit Role Capabilities", "access-control"),
          url: "/roles/edit-role-capabilities",
          page: {
            title: __("User Role Editor", "access-control"),
            description: "Edit user roles and capabilities to manage access control for your WordPress site."
          }
        },
        {
          title: __("Role Manager", "access-control"),
          url: "/roles/role-manager",
          page: {
            title: __("Change user's roles", "access-control"),
            description: "Easily add or remove roles for any user. You can assign multiple roles to a single user. Simply enter the username in the search field to get started."
          }
        },
        {
          title: __("Backup & Restore Role", "access-control"),
          url: "/roles/backup-and-restore",
          page: {
            title: __("Backup and restore your roles", "access-control"),
            description: "Use this section to backup your current user roles' and their configuration. You can also restore this data at any time by clicking the Restore backup button."
          }
        },
      ]
    },
    {
      title: __("Global Settings", "access-control"),
      url: "/settings",
      icon: Global,
      
      sub: [
        {
          title: __("Settings", "access-control"),
          url: "/settings/settings",
          page: {
            title: __("General Settings", "access-control"),
            description: "The Access Control plugin allows store admins to view their stores from a specific user’s perspective and act as that user."
          }
        },
        {
          title: __("Color Customizer", "access-control"),
          url: "/settings/color-customizer",
          page: {
            title: __("Customize Access Control Switcher Design", "access-control"),
            description: "Specify the colors of the background of the frontend admin switcher as well as the text color. Also select specific color that you want to set for the switch button, button text and more."
          },
        },
        {
          title: __("Permission", "access-control"),
          url: "/settings/permission",
          page: {
            title: __("Give Permission to Those Who Are Necessary to Your Business", "access-control"),
            description: "Allow selected user roles for access control so they can easily view as a customer and debug an issue from their perspective."
          },
        },
      ]
    },

    {
      title: __("More", "access-control"),
      url: "/more",
      icon: More,
      sub: [
        {
          title: __("Reset", "access-control"),
          url: "/more/reset",
          page: {
            title: __("Reset", "access-control"),
            description: "Want to start over? Go back to the how our plugin was first installed on your site."
          }
        },
        {
          title: __("Extra", "access-control"),
          url: "/more/extra",
          page: {
            title: "Extra",
            description: "These are extra features provided by our plugin Access Control. You can use them to make your access control experience even better."
          }
        },
        
      ]
    },
    
  ];
  const communityItems = [
    {
      title: __("Feedback", "access-control"),
      url: "https://wordpress.org/support/plugin/access-control/",
      icon: Feedback,
      sub: [],
    },
    {
      title: __("Review", "access-control"),
      url: "https://wordpress.org/support/plugin/access-control/reviews/#new-post",
      icon: Review,
      sub: [],
    },
    {
      title: __("Support Center", "access-control"),
      url: "https://wordpress.org/support/plugin/access-control/",
      icon: SupportCenter,
      sub: [],
    },
    {
      title: __("Other Plugin", "access-control"),
      url: "/other-plugin",
      icon: OtherPlugin,
      sub: [],
    },
  ];

export const MenuProvider = ({ children }) => {
    const [settingData, setSettingData] = useState({});
    const [settingLoading, setSettingLoading] = useState(true);
    const [reload, setReload] = useState(0);
    const [changeCount, setChangeCount] = useState(false);

    return (
        <MenuContext.Provider
            value={{
                settingData, 
                setSettingData,
                reload, 
                setReload,
                settingLoading,
                menuData,
                communityItems,
                changeCount, 
                setChangeCount,
            }}
        >
            {children}
        </MenuContext.Provider>
    );
};

export const useMenu = () => useContext(MenuContext);

